module.exports = __webpack_public_path__ + "static/clothing-sunglasses-66902a412237767912aa4902f4a88c3a.jpg";